// extracted by mini-css-extract-plugin
module.exports = {"linkCol":"DesktopFooter_linkCol__SSlZr","footerLink":"DesktopFooter_footerLink__6cXgi"};